export default __webpack_public_path__ + "static/media/rectangle.d5a80318.png";